export default "__VITE_ASSET__8cccc473__"